import * as angular from "angular";
import {IController} from "angular";

export class TagsTableComponent implements IController {

  infiniteScroll: any;
  canEdit: boolean;
  isShowOnDriverApp: boolean;
  isShowOnWorkforceApp: boolean;
  isShowOnConsole: boolean;
  onEditTag: Function;
  onDeleteTag: Function;

}

angular
  .module('bringoz.admin.tags')
  .component('tagsTable', {
    bindings: {
      isShowOnDriverApp: '<',
      isShowOnWorkforceApp: '<',
      isShowOnConsole: '<',
      canEdit: '<',
      infiniteScroll: '<?',
      onEditTag: '&',
      onDeleteTag: '&'
    },
    template: require('./tags-table.html').default,
    controller: TagsTableComponent
  });

